import { createSelector } from 'reselect'

const getAlerts = state => state.alertState || {}

export const selectAlert = createSelector(getAlerts, alerts => alerts.alert)
